import { Alert } from "@mui/material";
import React, { FC } from "react";
import { CustomException } from "../../types/customException";
import { useIntl } from "react-intl";
import { replaceKeysInMessage } from "../../utils/replaceKeys";

interface ErrorMessageProps {
	error: CustomException | string;
}

export const ErrorMessage: FC<ErrorMessageProps> = ({ error }) => {
	const { formatMessage } = useIntl();
	return (
			<Alert variant="filled" severity="error">
					{error instanceof CustomException
						? replaceKeysInMessage(
								formatMessage({
									id: `apiResponse.${error.friendlyKey}`,
									defaultMessage: error.message,
								}),
								error.keys
						  )
						: formatMessage({
								id: "apiResponse.genericError",
								defaultMessage:
									"Ups! Algo salió mal, intente de nuevo más tarde.",
						  })}
			</Alert>
	);
};
